<template>
<el-container>
  <publicHeader :currencyShow="currencyShow" @hotelLanguage="hotelLanguage"></publicHeader>
  <el-main>
    <div class="main" ref="element" :style="{ height: `${elementHeight}px` }">
      <div style="color:#4F4C4C;">
        <!--成功 开始-->
        <div v-if="SuccessDiv" class="StatusDiv">
          <div class="order-status-img" style="background: rgb(52, 196, 71);">
            <img style="width: 40px; height: 40px; margin: 20px;" src="https://res.roompai.com/static/img/account/my-payment-yes.png">
          </div>
          <!-- <div class="order-status-img" style="width:80px;height:80px;background:#34C447;border-radius: 50%; margin: 0px auto 20px;">
            <img style="width:40px; height:40px;margin: 20px;" src="https://res.roompai.com/static/img/account/my-payment-yes.png">
          </div> -->
          <div class="reserve-text-one">{{$t('bookingIsNowComplete')}}</div>
          <div class="reserve-text-two" v-if="language === 'zh'">{{$t('bookingReference')}}<span style="color:#5392F9;">{{orderno}}</span></div>
          <div class="reserve-text-two" v-else>{{$t('bookingReference')}} <span style="color:#5392F9;">{{orderno}}</span></div>
          <div class="reserve-text-two">
            {{$t('minutesTenYouBookingSendEmail')}}：<span style="color:#5392F9;" v-if="ismobile === false">{{userEmail}}</span>
          </div>
          <div style="color:#5392F9;font-size: 14px;" v-if="ismobile === true">
            {{userEmail}}
          </div>
          <div style="margin-top: 30px;" v-if="ismobile === false">
            <a><el-button class="pay_button" @click="cityRouterLink">{{$t('backHome')}}</el-button></a>
            <a><el-button class="pay_button" @click="lookMyBook">{{$t('manageMyBookings')}}</el-button></a>
            <!-- <el-button class="pay_button travel_button" :class="{'home_button': isPrint}" @click="downloadPdf">{{$t('printVoucher')}}</el-button> -->
          </div>
          <div style="margin-top: 30px;" v-else>
            <div><a><el-button class="pay_button" @click="cityRouterLink">{{$t('backHome')}}</el-button></a></div>
            <div>
              <a><el-button class="pay_button" @click="lookMyBook">{{$t('manageMyBookings')}}</el-button></a>
            </div>
            <!-- <el-button class="pay_button travel_button" :class="{'home_button': isPrint}" @click="downloadPdf">{{$t('printVoucher')}}</el-button> -->
          </div>
        </div>
        <!--成功 结束-->
        <!--失败 开始-->
        <div v-if="FailedDiv" class="StatusDiv">
          <div class="order-status-img" style="background:red;">
            <img style="width:50px; height:50px;margin: 15px;" src="https://res.roompai.com/static/img/account/my-error.png">
          </div>
          <!-- <div class="order-status-img" style="width:80px;height:80px;background:red;border-radius: 50%; margin: 0px auto 20px;">
            <img style="width:50px; height:50px;margin: 15px;" src="https://res.roompai.com/static/img/account/my-error.png">
          </div> -->
          <div class="fail-reserve-text-two">
            {{$t('noRooms')}}
          </div>
          <div>
            <div>
              <!-- { name: 'HotelDetail',  query: { 'hotelid': paramsArr.hotelid, 'region': paramsArr.region, 'start_date': paramsArr.checkin, 'end_date': paramsArr.checkout, 'room': paramsArr.room, 'adult': paramsArr.adult, 'child': paramsArr.childNums, 'source': source} } -->
              <router-link :to="{name:'HotelDetail', params: {'querys': common.linkEncode({ 'hotelid': paramsArr.hotelid, 'region': paramsArr.region, 'start_date': paramsArr.checkin, 'end_date': paramsArr.checkout, 'room': paramsArr.room, 'adult': paramsArr.adult, 'child': paramsArr.childNums, 'source': source}, 'obj')}}">
                <el-button class="pay_button_fail">{{$t('bookCurAotherRoom')}}</el-button>
              </router-link>
              <el-button class="pay_button home_button" @click="cityRouterLink">{{$t('backHome')}}</el-button>
            </div>
          </div>
        </div>
        <!--失败 结束-->
        <!--待确认 开始-->
        <div v-if="WaitConfirmationDiv" class="StatusDiv">
          <div style="display:block;">
            <img src="https://res.roompai.com/static/img/order/waitconfirmation.png" style="width:80px; height:80px;">
          </div>
          <div class="reserve-text-one">
            <div style="display:inline-block;">{{$t('pending')}}</div>
            <div style="display:inline-block;">
              <el-popover popper-class="popverText" placement="left" trigger="click">
                <div style="font-size:12px;">
                  <div v-html="$t('pendingMeanBookingnotCompleteYouBookingHotel')"></div>
                  <div>{{$t('limitedInventoriesAndBestPrice')}}</div>
                  <div v-if="language === 'zh'">{{$t('hotelAndYouWillReceiveFinalBookingStatusInboxLeft')}}{{minutes}}{{$t('hotelAndYouWillReceiveFinalBookingStatusInboxRight')}}</div>
                  <div v-else>{{$t('hotelAndYouWillReceiveFinalBookingStatusInboxLeft')}} {{minutes}} {{$t('hotelAndYouWillReceiveFinalBookingStatusInboxRight')}}</div>
                </div>
                <img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; margin-bottom: 7px;" slot="reference">
              </el-popover>
            </div>
          </div>
          <div class="reserve-text-two">
            {{$t('bookingReference')}}：<span style="color:#5392F9;">{{orderno}}</span>
          </div>
          <div class="reserve-text-two" v-if="language === 'zh'">
            {{$t('bookingIsPendingWekeepYouInformedMinutesLeft')}}{{minutes}}{{$t('bookingIsPendingWekeepYouInformedMinutesRight')}}
          </div>
          <div class="reserve-text-two" v-else>
            {{$t('bookingIsPendingWekeepYouInformedMinutesLeft')}} {{minutes}} {{$t('bookingIsPendingWekeepYouInformedMinutesRight')}}
          </div>
          <div class="reserve-text-two">
            {{$t('bookingStatusWilBeSendToYourEmail')}}: <span style="color:#5392F9;">{{userEmail}}</span>
          </div>
          <div>
            <div><a><el-button class="pay_button home_button" @click="cityRouterLink">{{$t('backHome')}}</el-button></a></div>
            <div>
              <a>
                <el-button class="pay_button travel_button" @click="lookMyBook">{{$t('manageMyBookings')}}</el-button>
              </a>
            </div>
            <!-- <router-link :to="{ name: 'tripDetail', query: { P: '1111' } }">
              <el-button class="pay_button travel_button">{{$t('printVoucher')}}</el-button>
            </router-link> -->
          </div>
        </div>
        <!--待确认 结束-->

        <!--立即确认 开始 (已废弃) -->
        <div v-if="InstantConfirmationDiv" style="width: 610px;">
          <div style="display:block;">
            <img src="https://res.roompai.com/static/img/order/waitconfirmation.png" style="width:80px; height:80px;">
          </div>
          <div class="reserve-text-one">
            <div style="display:inline-block;">{{$t('pending')}}</div>
            <div style="display:inline-block;">
              <el-popover popper-class="popverText" placement="right" trigger="click">
                <div style="font-size:12px;">
                  <div>订单处于待确认状态，指的是由于网络或其他传输问题，导致订单不确定是否预订成功。</div>
                  <div>请您不要着急，我们会尽快为您查询价格和库存是否有效，10分钟内会为您更新订单状态。</div>
                  <div>给您带来的不变，敬请谅解。</div>
                </div>
                <img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; margin-bottom: 7px;" slot="reference">
              </el-popover>
            </div>
          </div>
          <div class="reserve-text-two">
            预订编码：<span style="color:#5392F9;">2039387584</span>
          </div>
          <div class="reserve-text-two">
            由于网络传输问题，订单现在处于待确认状态，我们会在10分钟内帮您确认好订单的状态。
          </div>
          <div class="reserve-text-two">
            订单状态通知同时会发送至您的邮箱：<span style="color:#5392F9;">roomhaha@gmail.com</span>
          </div>
          <div>
            <router-link :to="{name:'Home', params: {'querys': common.linkEncode({'source': source}, 'obj')}}">
              <el-button class="pay_button home_button">返回首页</el-button>
            </router-link>
            <router-link :to="{name:'tripDetail', params: {'querys': common.linkEncode({'P': 1111}, 'obj')}}">
              <el-button class="pay_button travel_button">查看行程</el-button>
            </router-link>
            <el-button class="pay_button travel_button" @click="downloadPdf">打印行程单</el-button>
          </div>
        </div>
        <!--立即确认 结束-->
      </div>
    </div>
  </el-main>
  <publicFooter></publicFooter>
  <!--行程单-->
<div hidden>
  <div class="pdf" id="pdfDom" ref="pdfDom">
    <div class="pdf-main">
      <div style="padding:10px 20px;">
        <div style="width: 1040px;height: 53px;">
          <div style="display: inline-block; height: 53px;float: left;width:680px;">
            <img class="pdf-logo" src="/static/img/pdf-logo.jpg" />
          </div>
          <div class="logo-text">Booking Confirmation</div>
        </div>
        <div role="progressbar" aria-valuenow="4" aria-valuemin="0" aria-valuemax="5" class="el-progress el-progress--line is-exception">
          <div class="score-bar">
            <div class="scoreNo" style="height: 7px;">
              <div class="scoreYes" style="width: 90%;">
              </div>
            </div>
          </div>
        </div>
        <div class="pdf-content">
            <div class="pdf-title">Booking Information</div>
            <div class="pdf-information" :class="{'pdf-information-top': id === 'Booking reference'}" v-for="(item, id) in tripPdfInformation" :key="id">
              <div class="information-left">{{id}}:</div>
              <div class="information-right">{{item}}</div>
            </div>
        </div>
        <div class="pdf-content">
            <div class="pdf-title">Services provided</div>
            <div style="margin-top: 10px;font-weight: 400;font-size: 14px;width:1040px;line-height: 28px;">
            <table cellpadding='0' cellspacing='2' border='0' style="width:100%;">
                <tbody>
                <tr class="tr border-tr">
                    <td style="width:10%;">Check-in</td>
                    <td style="width:10%;">Check-out</td>
                    <td style="width:8%;">Room</td>
                    <td style="width:41%;">Room type</td>
                    <td style="width:15%;">Board</td>
                    <td style="width:8%;">Adults</td>
                    <td style="width:8%;">Children</td>
                </tr>
                <tr><td colspan="7" style=" margin:2px;border-bottom: 0.5px solid rgba(215, 215, 215, 1);"></td></tr>
                <tr class="tr">
                    <td style="width:10%;">{{orderDetail.checkin_val}}</td>
                    <td style="width:10%;">{{orderDetail.checkout_val}}</td>
                    <td style="width:8%;">{{orderDetail.roomcount}}</td>
                    <td style="width:40%; padding-right:1%;">{{orderDetail.parent_room_en}}</td>
                    <td style="width:15%;">{{orderDetail.board}}</td>
                    <td style="width:8%;">{{orderDetail.adult_num}}</td>
                    <td style="width:8%;">{{orderDetail.child_num}}</td>
                </tr>
                </tbody>
            </table>
          </div>
        </div>
        <div class="pdf-content" style="height:150px;">
          <div class="pdf-title">Payment details</div>
          <div class="pdf-payment pdf-information-top">
            <div class="pdf-payment-info">
              <div class="payment-left">Room price ({{orderDetail.roomcount}} room x {{orderDetail.wan}} night )</div>
              <div class="payment-right">{{orderDetail.unitprice_all}}</div>
            </div>
            <div class="pdf-payment-info">
              <div class="payment-left">Resort fee (Pay at the property)</div>
              <div class="payment-right">{{orderDetail.onshopprice}}</div>
            </div>
            <div class="pdf-payment-info">
              <div class="payment-left">City tax (Pay at the property)</div>
              <div class="payment-right">{{orderDetail.tax_new}}</div>
            </div>
            <div class="pdf-payment-info">
              <div class="payment-left">Final price</div>
              <div class="payment-right">{{orderDetail.totalprice_new}}</div>
            </div>
          </div>
          <div class="pdf-payment-right pdf-information-top">
            <div>Remarks:</div>
            <div>Roompai only charge you the room price. Others (for example, resort fee, city tax and so) will have to be paid  when you check in at the property in the property's currency (exchange rates may vary).</div>
          </div>
        </div>
        <div class="pdf-content" style="height:130px; margin-top:25px;">
            <div class="pdf-title">Cancellation policy</div>
            <div class="pdf-information pdf-policy">
              <div class="pdf-policy-text" v-if="orderDetail.cancel === '1'">Free cancellation before {{orderDetail.free_cancel_date}}  (Hotel's Local Time)</div>
              <div class="pdf-policy-text" v-else>This booking is non refundable. There will be no refund if you cancel it.</div>
              <div class="policy-remarks">
                <div>Remarks:</div>
                <div>If you fail to arrive or cancel the booking after check-in date, no refund will be given.</div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="pdf-main">
      <div style="padding:10px 20px;">
        <div class="pdf-content" style="margin:0;">
          <div class="pdf-title">Contact us</div>
          <div class="pdf-payment pdf-information-top" style="height:100px;">
            <div class="pdf-policy-text">Customer service phone number</div>
            <div class="pdf-policy-text" style="font-weight:100;">
              <span style="width:48%; float:left;">0411-84949537</span>
              <span style="width:48%; float:left;">(For domestic call)</span>
              </div>
            <div class="pdf-policy-text" style="font-weight:100;">
              <span style="width:48%; float:left;">0086-411-84949537</span>
              <span style="width:48%; float:left;">(For international call)</span>
            </div>
          </div>
          <div class="pdf-contact-right pdf-information-top" style="height:100px;">
            <div class="pdf-policy-text">Customer service email</div>
            <div class="pdf-policy-text" style="font-weight:100;">cs_client@51smart.com</div>
          </div>
          <div class="policy-remarks" style="clear:both;">
            <div>Remarks:</div>
            <div>You can always contact us if you come across any problems.</div>
          </div>
        </div>
        <div class="pdf-content pdf-notice">
          <div class="pdf-title">Important notice</div>
          <div>
            1. The price shown above DOES NOT include any applicable hotel service fees, charges for optional incidentals (such as minibar snacks or telephone calls), or regulatory surcharges. The hotel will assess these fees, charges, and surcharges upon check-out.
          </div>
          <div>
            2. The property will keep the room for you till check in date. If you fail to arrive before that day, your room might be get back by the property.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</el-container>
</template>

<script>
import { getCityId } from '@/request/hotel.js'
import { downloadTrip, orderPayResultShow } from '@/request/order.js'
import html2pdf from 'html2pdf.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
export default {
  name: 'PayResult',
  components: {
    publicFooter,
    publicHeader
  },
  data () {
    return {
      currencyShow: false, // 币种是否显示
      SuccessDiv: false,
      FailedDiv: false,
      WaitConfirmationDiv: false,
      InstantConfirmationDiv: false,
      orderno: '',
      hotelid: '',
      userEmail: '',
      paramsArr: {},
      tripPdfInformation: {},
      orderDetail: [],
      hotelDetail: [],
      elementHeight: document.documentElement.clientHeight,
      city: {},
      cityname: '',
      language: this.common.languageSet(this),
      ismobile: false,
      isBackHome: true,
      isBooking: false,
      isPrint: false,
      minutes: '60',
      source: 'roompai'
    }
  },
  created () {
    if (document.documentElement.clientWidth < 1001) {
      this.ismobile = true
    } else {
      this.ismobile = false
    }
    this.payResult()
    this.getCityIdFun()
  },
  watch: {
    language: function (newCur, oldCur) {
      this.payResult()
      this.getCityIdFun()
    }
  },
  mounted () {
    var source = this.common.linkQuerys.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
  },
  methods: {
    hotelLanguage (language) {
      this.language = language
    },
    payResult: function () {
      let locationHref = window.document.location.href
      var params = this.$route.params
      var orderResultData = localStorage.getItem('orderResultData')
      if (JSON.stringify(params) === '{}' && orderResultData !== '{}') {
        params = JSON.parse(orderResultData)
      }
      this.paramsArr = params

      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var currency = this.common.currencySet(this)
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)

      this.orderno = params.orderno
      this.hotelid = params.hotelid

      this.source = params.source
      // 订单结果数据
      var orderResultJson = {
        'token': token,
        'hotelid': this.hotelid,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums,
        'product': params.product,
        'time': time,
        'source': params.source,
        'orderno': params.orderno,
        'currency': currency,
        'operation': 'orderPayResultShow'
      }
      var orderResultShow = this.common.encryptionData(orderResultJson, this)
      // 1-待支付 2-待确认 3-已确认 4-已取消 5-拒单
      orderPayResultShow(orderResultShow).then(res => {
        if (res.flag === '001') {
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          // this.$router.push({name: 'login', query: {'source': this.source}})
          var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (['200'].includes(res.flag)) {
          this.orderno = res.data.orderno
          this.userEmail = res.data.email
          this.minutes = res.data.minutes
          if (['3'].includes(res.data.orderStatus)) {
            this.SuccessDiv = true
          } else if (['2'].includes(res.data.orderStatus)) {
            // if (params.flag === '160') {
            this.WaitConfirmationDiv = true // 待确认产品
            // } else {
            //   this.InstantConfirmationDiv = true // 立即确认下单超时
            // }
          } else if (['5'].includes(res.data.orderStatus)) {
            this.FailedDiv = true
          }
        }

        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(orderResultShow, res, requestTime, responseTime)
        })
      })
    },
    JumpHomePage () {
      // this.$router.push('WritePay')
      var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      this.$router.push({name: 'WritePay', params: {'querys': newQuerys}})
    },
    // 获取城市ID
    getCityIdFun: function () {
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      var DataJson = {'hotelid': this.hotelid, 'operation': 'getCityId', 'time': time, 'sessionid': sessionid}
      var Data = this.common.encryptionData(DataJson, this)
      getCityId(Data).then(res => {
        this.city = res.data.hotelCity
        if (this.language === 'zh') {
          this.cityname = this.city.chinese_name
        } else {
          this.cityname = this.city.city
        }
      })
    },
    cityRouterLink: function () {
      this.isBackHome = true
      this.isBooking = false
      this.isPrint = false
      var regionSel = {'value_en': this.city.city, 'value_zh': this.city.chinese_name, 'type_id': 1, 'type_data_id': this.city.id}
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      var cityname = this.city.city
      if (this.common.languageSet(this) === 'zh') {
        cityname = this.city.chinese_name
      }
      var date1 = new Date()
      date1.setDate(date1.getDate() + 1)
      var date2 = new Date(date1)
      date2.setDate(date1.getDate() + 1)

      var month = date1.getMonth() + 1
      var monthSelect = (month) < 10 ? '0' + (month).toString() : (month).toString()
      var dateSelect = (date1.getDate()) < 10 ? '0' + (date1.getDate()).toString() : (date1.getDate()).toString()
      var startDate = (date1.getFullYear()) + '-' + monthSelect + '-' + dateSelect

      var month2 = date2.getMonth() + 1
      var monthSelect2 = (month2) < 10 ? '0' + (month2).toString() : (month2).toString()
      var dateSelect2 = (date2.getDate()) < 10 ? '0' + (date2.getDate()).toString() : (date2.getDate()).toString()
      var endDate = (date2.getFullYear()) + '-' + monthSelect2 + '-' + dateSelect2
      // var startDate = (date1.getFullYear()) + '-' + (date1.getMonth() + 1) + '-' + (date1.getDate())
      // var endDate = (date2.getFullYear()) + '-' + (date2.getMonth() + 1) + '-' + (date2.getDate())
      // 无母房型有报价
      var searchJson = {'type': 1, 'type_id': this.city.id, 'region': cityname, 'start_date': startDate, 'end_date': endDate, 'room': 1, 'adult': 2, 'child': 0}
      if (this.source !== '' && this.source !== 'roompai' && this.source !== undefined && this.source !== null) {
        searchJson['source'] = this.source
      }
      localStorage.setItem('searchData', JSON.stringify(searchJson))

      // this.$router.push({name: 'HotelList', query: searchJson})
      var newQuerys = this.common.linkEncode(searchJson, 'obj')
      this.$router.push({name: 'HotelList', params: {'querys': newQuerys}})
    },
    gotoManage () {
      this.isBackHome = false
      this.isBooking = true
      this.isPrint = false
      // this.$router.push({name: 'tripDetail', query: { 'orderno': this.orderno, 'source': this.source }})
      var newQuerys = this.common.linkEncode({ 'orderno': this.orderno, 'source': this.source }, 'obj')
      this.$router.push({name: 'tripDetail', params: {'querys': newQuerys}})
    },
    downloadPdf () {
      this.isBackHome = false
      this.isBooking = false
      this.isPrint = true
      // 获取数据
      if (this.orderno === undefined) {
        return false
      }
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined) {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        // this.$router.push({name: 'login', query: {'source': this.source}})
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': this.orderno,
        'time': time,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      console.log(data)
      downloadTrip(data).then(res => {
        console.log(res)
        if (res.flag === '001') {
          let locationHref = window.document.location.href
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          // this.$router.push({name: 'login', query: {'source': this.source}})
          var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '200') {
          this.hotelDetail = res.data.hotelDetail
          this.orderDetail = res.data.orderDetail
          this.tripPdfInformation = {'Booking reference': this.orderDetail.orderno, 'Creation date': this.orderDetail.create_date, 'Hotel': this.hotelDetail.hotelname, 'Address': this.hotelDetail.hoteladdress, 'Property Contact Number': this.hotelDetail.tel, 'Lead guest': this.orderDetail.leadguest}
          let data = Object.assign({}, this.$refs)
          html2pdf(data.pdfDom, {
            margin: 1,
            filename: this.orderno + '.pdf',
            image: {
              type: 'jpeg',
              quality: 1
            },
            html2canvas: {
              scale: 2
            },
            jsPDF: {
              unit: 'pt',
              format: 'a4',
              orientation: 'landscape'
            }
          })
        }
      })
    },
    lookMyBook () {
      // 点击完成 埋点记录
      this.clickPageAction('view_book', '', {'orderno': this.orderno})

      // this.$router.push({ name: 'tripDetail', query: { 'orderno': this.orderno, 'source': this.source } })
      var newQuerys = this.common.linkEncode({ 'orderno': this.orderno, 'source': this.source }, 'obj')
      this.$router.push({name: 'tripDetail', params: {'querys': newQuerys}})
    }
  }
}
</script>

<style scoped>
.el-main {background-color: rgba(240, 242, 245, 1);color: #4F4C4C;text-align: center;line-height:35px;}
.main {width:1100px;margin: 0 auto;height:1100px;display: flex;justify-content: center;align-items: center;}
.order-status-img{width: 80px; height: 80px; border-radius: 50%; margin: 0px auto 20px;}
.order-status-img img{width:35px;height:35px; margin:7.5px;}
.reserve-text-one {font-size: 22px;font-style: normal;font-weight:650;}
.reserve-text-two{font-size: 14px;}
.fail-reserve-text-two{font-size: 16px;}
.pay_button{cursor:pointer;/*width:25%;*/height:36px;font-size:14px; border:none;border-radius:4px; margin: 0px 6px;text-decoration:none;}
.pay_button:hover,.pay_button:focus{background-color:rgba(79, 76, 76, 1) !important;color: rgb(252, 210, 5) !important;border:none !important;}

.home_button{background-color:rgba(79, 76, 76, 1) !important;color: rgb(252, 210, 5) !important;}
.home_button a{color: rgb(252, 210, 5) !important;}
.travel_button{background-color:rgba(255, 255, 255, 1);color:#4F4C4C;}
.travel_button a{color:#4F4C4C;}
/* .StatusDiv{max-width:750px;} */
/* .travel_button a:hover{color: rgb(252, 210, 5);}
.travel_button:focus{background-color:rgba(255, 255, 255, 1);color:#4F4C4C;} */
.pay_button_fail{/*width:48%;*/height:36px;background-color:rgba(79, 76, 76, 1);color: rgb(252, 210, 5);border:none;font-size:14px; border:none;border-radius:4px; margin: 0px 6px; margin-top:10%;text-decoration:none;}
.home_button_fail{width:40%;height:36px;font-size:14px; border:none;border-radius:4px; margin-right:4%; margin-top:10%;text-decoration:none;background-color:rgba(255, 255, 255, 1);color:#4F4C4C;}
.popverText{ font-size:12px;width:20%;}
@media screen and (max-width: 1000px) {
.main {width:95%;}
.reserve-text-one{ font-size:18px;}
.pay_button, .home_button_fail{width:90%; margin-top: 10px;}
.pay_button_fail{width:90%;}
.pay_button:hover{background-color:rgba(79, 76, 76, 1) !important;color: rgb(252, 210, 5) !important;border:none !important;}
.travel_button:hover{background-color:rgba(79, 76, 76, 1);color:rgb(252, 210, 5);border:none;}
}
</style>
<style lang="scss">
  /* 下载行程单 */
  .pdf{width:1080px;height:auto;font-size:14px; margin: 0 auto;}
  .pdf-main{width:100%;margin: 20px 0px;border:1px solid rgba(79, 76, 76, 1);height: 100%;}
  .pdf-logo{width: 193px;height: 32px; margin:10px 0px;}
  .score-bar{width: 100%;-webkit-box-sizing: border-box;box-sizing: border-box;}
  .scoreNo{height: 6px;border-radius: 100px;background-color: rgba(79, 76, 76, 1);overflow: hidden;position: relative;vertical-align: middle;}
  .scoreYes{height: 100%;text-align: right;border-radius: 100px;line-height: 1;white-space: nowrap;-webkit-transition: width .6s ease;transition: width .6s ease;background-color:rgba(252, 210, 5, 1);}
  .logo-text{font-weight: 650;font-style: normal;font-size: 22px;color: #333;display: inline-block;float: right;height: 53px;line-height: 53px;width:250px;}
  /* .tr td{text-align:center;} */
  .pdf-content{margin-top:10px;}
  .pdf-information{height:28px; line-height: 28px;}
  .pdf-information-top{margin-top:10px;}
  .pdf-title{font-weight: 500;font-size: 18px;border-bottom: 1px solid rgba(215, 215, 215, 1);height: 34px;line-height: 34px;}
  .information-left{width:40%;height:100%;float:left;}
  .information-right{width:60%;height:100%;float:left;}
  .pdf-content th{font-weight: 400; color:#333; font-size: 14px;}
  .pdf-content .el-table th.el-table__cell.is-leaf{border-bottom: 1px solid #EBEEF5;}
  .pdf-content .el-table td.el-table__cell{border-bottom:none;}
  .pdf-payment{ float: left; width:48%; height:130px;}
  .pdf-payment-info{height:28px; line-height: 28px; width:100%;}
  .payment-left{width:70%; float:left;}
  .payment-right{width:30%; float:left;}
  .pdf-payment-right{ float:right; width:48%; height:110px; background-color: rgba(221, 223, 226, 0.2980392156862745); line-height: 22px;padding: 10px;}
  .pdf-policy-text{ height:28px; line-height:28px;}
  .policy-remarks{ background-color: rgba(221, 223, 226, 0.2980392156862745);line-height: 22px;padding: 10px 0;}
  .pdf-contact-right{float:right; width:48%; height:130px;line-height: 25px;}
  .pdf-notice div{line-height:28px;}
  </style>



// WEBPACK FOOTER //
// src/components/order/PayResult.vue